import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { headerType, renderTypeObj, StudentheaderType } from 'src/Helpers/constant';
import { contentTypeAction } from 'src/Redux/Action/htmlAction';
import HeaderOne from './HeaderOne';
import HeaderThree from './HeaderThree';
import HeaderTwo from './HeaderTwo';

const HeaderView = () => {
  const state = useSelector((state) => state.contentHTML.htmlContent);
  const { id, htmltype, mainid } = state;

  const navigate = useNavigate();
  const [arrayList, setArrayList] = useState([]);
  const dispatch = useDispatch();

  const param = useLocation();
  const urlthis = param.pathname.split('/');
  urlthis.shift();

  function getRenderType() {
    for (let i = 1; i < urlthis.length; i++) {
      return renderTypeObj[urlthis[i]];
    }
  }

  const renderType = getRenderType();

  const idx = Object.values(renderTypeObj).indexOf(renderType);
  const currentPath = Object.keys(renderTypeObj)[idx];

  const params = useParams();

  const nextHandler = () => {
    const myindex = arrayList.findIndex(function (item, i) {
      // return item._id === mainid;
      if (params.header && params.headertwo && params.headerthree) {
        if (item.type === headerType.header3) {
          return (
            item.slug === params.headerthree &&
            item.header2_slug === params.headertwo &&
            item.header1_slug === params.header &&
            item.chapter_slug === params.chapter &&
            item.book_slug === params.id
          );
        } else if (item.type === StudentheaderType.header3) {
          return (
            item.slug === params.headerthree &&
            item.header2_slug_clone === params.headertwo &&
            item.header1_slug_clone === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      } else if (params.header && params.headertwo) {
        if (item.type === headerType.header2) {
          return (
            item.slug === params.headertwo &&
            item.header1_slug === params.header &&
            item.chapter_slug === params.chapter &&
            item.book_slug === params.id
          );
        } else if (item.type === StudentheaderType.header2) {
          return (
            item.slug === params.headertwo &&
            item.header1_slug_clone === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      } else if (params.header) {
        if (item.type === headerType.header1) {
          return item.slug === params.header && item.chapter_slug === params.chapter && item.book_slug === params.id;
        } else if (item.type === StudentheaderType.header1) {
          return (
            item.slug === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      }
    });

    dispatch(
      contentTypeAction({
        renderType: renderType,
        id: id,
        htmltype: htmltype,
        mainid: arrayList[myindex + 1]?._id,
        type: arrayList[myindex + 1]?.type ? arrayList[myindex + 1]?.type : 'chapter',
        routerType: 'HEADER',
        counterNum: myindex,
        isRerender: true,
      })
    );

    if (
      arrayList[myindex + 1].type === headerType.header3 ||
      arrayList[myindex + 1].type === StudentheaderType.header3
    ) {
      // header 3
      navigate(
        `/library/${params.id}/${params.chapter}/${params.header}/${params.headertwo}/${arrayList[myindex + 1].slug}`
      );
    } else if (
      arrayList[myindex + 1].type === headerType.header2 ||
      arrayList[myindex + 1].type === StudentheaderType.header2
    ) {
      // header 2
      navigate(`/library/${params.id}/${params.chapter}/${params.header}/${arrayList[myindex + 1].slug}`);
    } else if (
      arrayList[myindex + 1].type === headerType.header1 ||
      arrayList[myindex + 1].type === StudentheaderType.header1
    ) {
      // header 1
      navigate(`/library/${params.id}/${params.chapter}/${arrayList[myindex + 1].slug}`);
    } else {
      // chapter
      navigate(`/library/${params.id}/${arrayList[myindex + 1].slug}`);
    }
  };

  const prevHandler = () => {
    const myindex = arrayList.findIndex(function (item, i) {
      // return item._id === mainid;
      if (params.header && params.headertwo && params.headerthree) {
        if (item.type === headerType.header3) {
          return (
            item.slug === params.headerthree &&
            item.header2_slug === params.headertwo &&
            item.header1_slug === params.header &&
            item.chapter_slug === params.chapter &&
            item.book_slug === params.id
          );
        } else if (item.type === StudentheaderType.header3) {
          return (
            item.slug === params.headerthree &&
            item.header2_slug_clone === params.headertwo &&
            item.header1_slug_clone === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      } else if (params.header && params.headertwo) {
        if (item.type === headerType.header2) {
          return (
            item.slug === params.headertwo &&
            item.header1_slug === params.header &&
            item.chapter_slug === params.chapter &&
            item.book_slug === params.id
          );
        } else if (item.type === StudentheaderType.header2) {
          return (
            item.slug === params.headertwo &&
            item.header1_slug_clone === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      } else if (params.header) {
        if (item.type === headerType.header1) {
          return item.slug === params.header && item.chapter_slug === params.chapter && item.book_slug === params.id;
        } else if (item.type === StudentheaderType.header1) {
          return (
            item.slug === params.header &&
            item.chapter_slug_clone === params.chapter &&
            item.book_slug_clone === params.id
          );
        }
      }
    });

    dispatch(
      contentTypeAction({
        renderType: renderType,
        id: id,
        htmltype: htmltype,
        mainid: arrayList[myindex - 1]._id,
        type: arrayList[myindex - 1].type ? arrayList[myindex - 1].type : 'chapter',
        routerType: 'HEADER',
        counterNum: myindex,
      })
    );

    if (
      arrayList[myindex - 1].type === headerType.header3 ||
      arrayList[myindex - 1].type === StudentheaderType.header3
    ) {
      // header 3
      navigate(
        `/library/${params.id}/${params.chapter}/${params.header}/${params.headertwo}/${arrayList[myindex - 1].slug}`
      );
    } else if (
      arrayList[myindex - 1].type === headerType.header2 ||
      arrayList[myindex - 1].type === StudentheaderType.header2
    ) {
      // header 2
      navigate(`/library/${params.id}/${params.chapter}/${params.header}/${arrayList[myindex - 1].slug}`);
    } else if (
      arrayList[myindex - 1].type === headerType.header1 ||
      arrayList[myindex - 1].type === StudentheaderType.header1
    ) {
      // header 1
      navigate(`/library/${params.id}/${params.chapter}/${arrayList[myindex - 1].slug}`);
    } else {
      // chapter
      navigate(`/library/${params.id}/${arrayList[myindex - 1].slug}`);
    }
  };

  const RenderHeader = () => {
    if (params.headerthree) {
      return <HeaderThree setArrayList={setArrayList} />;
    } else if (params.headertwo) {
      return <HeaderTwo setArrayList={setArrayList} />;
    } else if (params.header) {
      return <HeaderOne onNext={nextHandler} onPrev={prevHandler} setArrayList={setArrayList} />;
    }
  };

  return <React.Fragment>{RenderHeader()}</React.Fragment>;
};

export default HeaderView;
